import { DEBUG } from './constants'

// Routes that require database access - only show debug on these routes
const DB_DEPENDENT_PATHS = [
  '/survey/create',
  '/survey/results',
  '/survey/manage',
  '/survey/insights', 
  '/auth'
];

// Check if the current route requires database access
function isProtectedRoute() {
  const currentPath = window.location.pathname;
  return DB_DEPENDENT_PATHS.some(route => 
    currentPath.startsWith(route) || 
    (currentPath.includes('/survey/') && !currentPath.includes('/thank-you'))
  );
}

// Define a type that includes both the enum keys and string literals for better compatibility
export type DebugArea = keyof typeof DEBUG | 
  "SURVEY" | 
  "NAVIGATION" | 
  "STATE" | 
  "SURVEY_CREATOR" | 
  "SURVEY_INSIGHTS" | 
  "SURVEY_SUBMISSION" | 
  "ROLE_SELECTION" | 
  "AI_PROCESSOR" | 
  "AI_PROVIDER" | 
  "ADMIN_ACCESS" | 
  "SIGNUP" |
  "SURVEY_PROCESSING" |
  boolean

// Helper function to convert DEBUG object keys to DebugArea
export function asDebugArea(key: keyof typeof DEBUG): DebugArea {
  return key;
}

/**
 * Debugging utility for consistent logging
 */
export function debug(area: DebugArea, message: string, data?: any) {
  // Skip debug logging on non-protected routes
  if (!isProtectedRoute()) {
    return;
  }
  
  // If area is a boolean or not a key in DEBUG, skip
  if (typeof area === 'boolean' || !(area in DEBUG)) {
    return;
  }
  
  const isEnabled = DEBUG[area as keyof typeof DEBUG];
  if (isEnabled) {
    const timestamp = new Date().toISOString();
    if (data) {
      console.log(`[${area}] [${timestamp}]`, message, data);
    } else {
      console.log(`[${area}] [${timestamp}]`, message);
    }
  }
}

export function debugGroup(area: DebugArea | keyof typeof DEBUG, label: string, fn: () => void) {
  if (process.env.NODE_ENV === 'development' || 
      (typeof area === 'string' && Object.prototype.hasOwnProperty.call(DEBUG, area) && DEBUG[area as keyof typeof DEBUG])) {
    const timestamp = new Date().toISOString()
    console.group(`[${area}] [${timestamp}] ${label}`)
    fn()
    console.groupEnd()
  }
}

export function debugState(area: DebugArea | keyof typeof DEBUG, label: string, state: any) {
  if (process.env.NODE_ENV === 'development' || 
      (typeof area === 'string' && Object.prototype.hasOwnProperty.call(DEBUG, area) && DEBUG[area as keyof typeof DEBUG])) {
    const timestamp = new Date().toISOString()
    console.group(`[${area}] [${timestamp}] ${label}`)
    console.log('State:', state)
    console.groupEnd()
  }
}